'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("abonnementSyntheseMailService", function ($http, $modal) {
  var createPopinOptions = {
    controller: "AbonnementSyntheseMailPopinController",
    template: require("./abonnementSyntheseMailPopin.html")
  };
  return {
    abonnementPopin: function abonnementPopin() {
      return $modal.open(_.extend(createPopinOptions, {
        vars: {},
        options: {
          escape: false
        }
      }));
    },
    delete: function _delete(abonnementId) {
      return $http.delete('/rest/abonnementSyntheseDette/delete/' + abonnementId);
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/abonnementSyntheseMail/abonnementSyntheseMailService.js
// module id = 2678
// module chunks = 13